import { render, staticRenderFns } from "./storyCreator.vue?vue&type=template&id=6bb10e36&scoped=true&"
import script from "./storyCreator.vue?vue&type=script&lang=js&"
export * from "./storyCreator.vue?vue&type=script&lang=js&"
import style0 from "./storyCreator.vue?vue&type=style&index=0&id=6bb10e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb10e36",
  null
  
)

export default component.exports